import { render, staticRenderFns } from "./DetailServiceReception.vue?vue&type=template&id=3c905f45&"
import script from "./DetailServiceReception.vue?vue&type=script&lang=js&"
export * from "./DetailServiceReception.vue?vue&type=script&lang=js&"
import style0 from "./DetailServiceReception.vue?vue&type=style&index=0&id=3c905f45&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c905f45')) {
      api.createRecord('3c905f45', component.options)
    } else {
      api.reload('3c905f45', component.options)
    }
    module.hot.accept("./DetailServiceReception.vue?vue&type=template&id=3c905f45&", function () {
      api.rerender('3c905f45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DetailServiceReception.vue"
export default component.exports